import React, { useEffect } from 'react';
import Text from '../../ui/Text';
import { detectMobile } from '../../utils/UiHelper';
import {
    CombosCarouselWrapper,
    CombosContent,
    CombosContentCarousel,
    CombosWrapper,
} from './styled';
import ArrowMy from 'images/icons/arrow-right-slider.svg';
import Flicking, { ViewportSlot } from '@egjs/react-flicking';
import '@egjs/react-flicking/dist/flicking.css';
import { Arrow } from '@egjs/flicking-plugins';
import { ScrollingAreaWrapper } from '../../ui/ScrollingArea/styled';
import CombosService from '../../utils/CombosService';
import CombosSkeleton from '../../components/SkeletonUI/CombosSkeleton/CombosSkeleton';
import { trackEvents } from '../../helpers/VaixHelpers/VaixTracking';
import {
    VAIX_TRACKING_LOCATIONS,
    VAIX_TRACKING_TYPE,
} from '../../constants/vaix/VaixTrcakingConstants';
import { connect } from 'react-redux';
import { getVaixEventsIds } from './helper';
import CombosItem from './CombosItem/CombosItem';
import CombosHint from './CombosHint/CombosHint';
import { getCookie, setCookie } from '../../utils/Helper';
import {
    getWidthOfTheElementById,
    handleOnChange,
} from '../../helpers/FlickerHelper/FlickerHelper';

const Combos = ({ auth }) => {
    const [isHiddenPrev, setIsHiddenPrev] = React.useState(true);
    const [isHiddenNext, setIsHiddenNext] = React.useState(false);
    const [getEventsPending, setGetEventsPending] = React.useState(false);
    const [combosData, setCombosData] = React.useState([]);
    const [currentSlideIndex, setCurrentSlideIndex] = React.useState(0);
    const [pending, setPending] = React.useState(true);
    const [panelPerView, setPanelPerView] = React.useState(3);
    const Slider = React.useRef(null);
    const [showHint, setShowHint] = React.useState(true);

    useEffect(() => {
        let isPresentCookie = !!getCookie('showHintForCombos');
        setShowHint(!isPresentCookie);
    }, []);

    useEffect(
        () => {
            checkArrows(currentSlideIndex);
        },
        [currentSlideIndex, panelPerView]
    );

    useEffect(
        () => {
            if (!auth.loginPending && !getEventsPending) {
                setGetEventsPending(true);
                CombosService.getCombo().then((res) => {
                    const { data, success } = res;
                    trackVaixImpressions(data);
                    if (success && data.length > 0) {
                        setCombosData(data);
                    }
                    setPending(false);
                    setGetEventsPending(false);
                });
            }
        },
        [auth.user?.userId, auth.loginPending]
    );

    const trackVaixImpressions = (data) => {
        const vaixEventsIds = [
            ...new Set(
                data.flatMap((item) => getVaixEventsIds(item, false, true))
            ),
        ];
        const dataForTracking = vaixEventsIds.map((id) => ({
            id,
        }));
        trackEvents(
            dataForTracking,
            VAIX_TRACKING_TYPE.impressions,
            VAIX_TRACKING_LOCATIONS.combos,
            '/sport/',
            auth?.user?.userId || 0,
            0,
            0,
            true
        );
    };

    const getContent = (combosData) => {
        if (detectMobile()) {
            return combosData.map((item, index) => {
                return (
                    <CombosItem
                        userId={auth.user?.userId || 0}
                        key={`${index}_${item}`}
                        markets={item}
                        firstItem={index === 0}
                        position={index + 1}
                    />
                );
            });
        } else {
            return combosData.map((item, index) => (
                <div key={`${index}_${item}`} style={{ marginRight: '8px' }}>
                    <CombosItem
                        userId={auth.user?.userId || 0}
                        markets={item}
                        firstItem={index === 0}
                        position={index + 1}
                    />
                </div>
            ));
        }
    };
    const handleCloseHint = () => {
        setCookie('showHintForCombos', 'true', 90);
        setShowHint(!showHint);
    };

    const checkArrows = (index, initial = false) => {
        const { hidePrevArrow, hideNextArrow } = handleOnChange(
            index !== undefined ? index : currentSlideIndex,
            combosData,
            panelPerView,
            initial
        );
        setIsHiddenPrev(hidePrevArrow);
        setIsHiddenNext(hideNextArrow);
    };

    const onReady = (e, initial = true) => {
        checkArrows(0, initial);
    };

    const onChange = (index) => {
        setCurrentSlideIndex(index);
    };

    const handleResize = (width) => {
        if (width > 900) {
            setPanelPerView(3);
            return 3;
        } else if (width < 900 && width > 700) {
            setPanelPerView(2.2);
            return 2.2;
        } else if (width < 700 && width > 220) {
            setPanelPerView(1.2);
            return 1.2;
        }
    };

    const plugins = [new Arrow()];

    return (
        <>
            {pending ? (
                <CombosSkeleton />
            ) : combosData.length > 0 ? (
                <CombosWrapper>
                    <Text
                        margin={'0 0 8px'}
                        padding={detectMobile() ? '0 0 0 16px' : '0'}
                        size={detectMobile() ? '16' : '20'}
                        lh={detectMobile() ? '24' : '30'}
                        weight={'700'}
                        color={'#1e1e1e'}
                    >
                        Mest spillede kombinationer
                    </Text>
                    <CombosContent>
                        {!detectMobile() &&
                            showHint && <CombosHint close={handleCloseHint} />}
                        {detectMobile() ? (
                            <ScrollingAreaWrapper gap={'8px'}>
                                {showHint && (
                                    <CombosHint close={handleCloseHint} />
                                )}
                                {getContent(combosData)}
                            </ScrollingAreaWrapper>
                        ) : (
                            <CombosCarouselWrapper id={'combos'}>
                                <CombosContentCarousel className="combos-carousel slider-container">
                                    <Flicking
                                        align={{ camera: '0', panel: '0' }}
                                        circularFallback={'linear'}
                                        circular={false}
                                        duration={400}
                                        panelsPerView={panelPerView}
                                        moveType={['strict']}
                                        bound={true}
                                        adaptive={false}
                                        inputType={[
                                            'touch',
                                            'mouse',
                                            'pointer',
                                        ]}
                                        preventClickOnDrag={true}
                                        onReady={(e) => {
                                            onReady(e, true);
                                        }}
                                        onAfterResize={(e) => {
                                            handleResize(e.width);
                                        }}
                                        onChanged={(e) => {
                                            onChange(e.index);
                                        }}
                                        plugins={plugins}
                                        ref={Slider}
                                    >
                                        {getContent(combosData)}
                                        <ViewportSlot>
                                            <button
                                                className={`flicking-arrow flicking-arrow-prev ${isHiddenPrev &&
                                                    'hidden'}`}
                                            >
                                                <img src={ArrowMy} alt="" />
                                            </button>

                                            <button
                                                className={`flicking-arrow flicking-arrow-next ${isHiddenNext &&
                                                    'hidden'}`}
                                            >
                                                <img src={ArrowMy} alt="" />
                                            </button>
                                        </ViewportSlot>
                                    </Flicking>
                                </CombosContentCarousel>
                            </CombosCarouselWrapper>
                        )}
                    </CombosContent>
                </CombosWrapper>
            ) : (
                <></>
            )}
        </>
    );
};

function mapStateToProps(state) {
    return { auth: state.auth };
}

export default connect(
    mapStateToProps,
    null
)(Combos);
